import { useEffect, useState } from "react";
import { TMXBASEADDRESS } from "Utils/EnvVars";
import useSession from "Utils/Hooks/useSession";

const useExternalScripts = (isAdded) => {
  const { session } = useSession();
  const [isLoaded, setIsLoaded] = useState(null);

  useEffect(() => {
    if (session && session.threatMetrixEnabled && !isAdded) {
      console.log("Session Id -> ", session.sessionId);
      let url =
        TMXBASEADDRESS +
        "?org_id=" +
        session.threatMetrixOrgId +
        "&session_id=" +
        session.sessionId;
      console.log(url);
      const head = document.querySelector("head");
      const script = document.createElement("script");
      script.setAttribute("src", url);
      head.appendChild(script);
      script.onload = () => {
        setIsLoaded(true);
      };
      return () => {
        head.removeChild(script);
      };
    }
  }, []);

  return { isLoaded };
};

export default useExternalScripts;
